module.exports = __webpack_public_path__ + "static/media/missing-things.21506b25.svg";